import RestApiModel from "@/api/Model/RestApiModel";

class ClassOfBusiness extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-class-of-businesses';
  }
}

export default ClassOfBusiness;
